import type { IPinnedCtaData } from 'components/molecules/pinned-cta/entities/types';
import type { HeaderViewService } from 'components/organisms/header-v2/service/header-view.service';
import type { ILandingPage } from 'src/pages/layouts/entities/types';
import type { LayoutService, TAvailableFooterTypes } from 'src/pages/layouts/services/layout.service';
import type { EProductType } from 'src/shared/types/product-type';

import type { LayoutComponent } from '../../../pages/layouts/layout.component';
import { isEmptyObject } from '../is-object-empty/is-object-empty';

function determineFooterVariant(layoutFooterType: TAvailableFooterTypes | undefined): TAvailableFooterTypes {
    return layoutFooterType ?? 'full';
}

export function applyLayout(
    headerViewService: HeaderViewService,
    layoutService: LayoutService,
    layoutComponent: LayoutComponent,
    viewData: ILandingPage,
    document: Document,
    productType: EProductType
): void {
    const secondaryMenuData = viewData?.layout?.footer_settings?.secondary_menu_data;

    if (viewData?.layout?.footer_settings) {
        layoutService.setFooterData(viewData.layout.footer_settings);
    }

    layoutService.setFooterSecondaryData(secondaryMenuData || null);

    layoutService.scheduleFooterRender(
        layoutComponent.footerContainer,
        determineFooterVariant(viewData?.layout?.footer_type),
        productType,
        viewData?.layout?.last_widget_color
    );

    if (secondaryMenuData?.length) {
        queueMicrotask(() => {
            layoutService
                .renderFooterSecondaryTo(layoutComponent.footerSecondaryContainer)
                .catch((error) => console.error('Failed to render footer secondary:', error));
        });
    } else {
        layoutService.clearFooterSecondary(layoutComponent.footerSecondaryContainer);
    }

    if (viewData?.layout?.page_background) {
        document.body.classList.add('page--background_' + viewData.layout.page_background);
    }

    if (viewData?.bannerOptions) {
        // To prevent NG0100 error - Expression has changed after it was checked
        queueMicrotask(() => {
            headerViewService.setOptions(viewData.bannerOptions);
        });
    }

    if (viewData?.layout.pinned_button) {
        const pinnedCta = {
            ...viewData.layout.pinned_button,
            isHeaderExisted: viewData.layout.header_type !== 'none',
            isBannerExisted: !isEmptyObject(viewData.bannerOptions),
            exists: true,
        } as IPinnedCtaData;

        // To prevent NG0100 error - Expression has changed after it was checked
        queueMicrotask(() => {
            headerViewService.setPinnedCtaOptions(pinnedCta);
        });
    }

    if (viewData?.layout?.is_article !== undefined) {
        layoutService.setIsArticle(viewData.layout.is_article);
    }
}
